<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Promotion.Referral.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sPromoCode">Promo Code</label>
                  <b-input id="sPromoCode" type="text" placeholder="" v-model.trim="sPromoCode"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sCreateOperator">Create Operator </label>
                  <b-input id="sCreateOperator" type="text" placeholder="" v-model.trim="sCreateOperator"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sModifyOperator">Modify Operator </label>
                  <b-input id="sModifyOperator" type="text" placeholder="" v-model.trim="sModifyOperator"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStatus">Status </label>
                  <b-form-select id="sStatus" :plain="true" :options="statusOption" v-model="sStatus" text-field="label" value-field="key">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sExpireOn">Expiry Date</label>
                  <b-input id="sExpireOn" type="date" placeholder="" v-model.trim="sExpireOn"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sSearchDateBy">Search Date By </label>
                  <b-form-select id="sSearchDateBy" :plain="true" :options="searchDateByOption" v-model="sSearchDateBy" text-field="label" value-field="key">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sFrom">From (yyyy/mm/dd 00:00:00)</label>
                  <b-input id="sFrom" type="date" placeholder="" v-model.trim="sFrom"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sTo">To (yyyy/mm/dd 23:59:59)</label>
                  <b-input id="sTo" type="date" placeholder="" v-model.trim="sTo"></b-input>
                </b-col>
              </b-row>
              <br/>
              <b-row>
                <b-col sm="4" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='icon-tag'></i> Promo Code List</h3>
            <div class="float-right">
              <b-button variant="warning" @click="exportCSV">Export</b-button>
              <b-button variant="danger" @click="verifyModal = true">Verify Registered Member</b-button>
              <b-button v-if="checkAccessPrivilege('Promotion.PromoCode.Create')" variant="primary" @click="addModal = true">Create Promo Code</b-button>
            </div>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(ExpireOn)="data">
                  {{ data.item.ExpireOn ? data.item.ExpireOn : '--'}}
                </template>
                <template v-slot:cell(TotalMember)="data">
                  {{ data.item.TotalMember === 0 ? 0 : `${data.item.TotalMember} Members` }}
                </template>
                <template v-slot:cell(Status)="data">
                  <b-badge v-if="data.item.Status === 1" variant="success">Active</b-badge>
                  <b-badge v-else-if="data.item.Status === 0" variant="danger">In-Active</b-badge>
                </template>
                <template v-slot:cell(Action)="data">
                  <b-button v-if="checkAccessPrivilege('Promotion.PromoCode.Update')" variant="info" @click="updateModalData(data.item)"><i class="icons icon-pencil"></i></b-button>
                  <b-button v-if="data.item.TotalMember > 0" variant="info" @click="showMemberListModal(data.item)"><i class="icons icon-eye"></i></b-button>
                </template>
              </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    
    <AddModal :status-option="statusOption" :operator="operator" :showAddModal="addModal" @cancelAdd="cancelAddModal()" />
    <UpdateModal :status-option="statusOption" :opefrator="operator" :showUpdateModal="updateModal" :updateData="updateData" @cancelUpdate="closeUpdateModal()"/>
    <MemberListModal :member-list="memberList" :promo-code="promoCode" :showMemberListModal="memberListModal" @closeModal="closeMemberListModal()" />
    <VerifyModal :showVerifyModal="verifyModal" @closeVerifyModal="verifyModal = false" />
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import moment from 'moment-timezone'
  import AddModal from './Create'
  import UpdateModal from './Update'
  import MemberListModal from './MemberList'
  import VerifyModal from './VerifyModal'

  export default {
    name: 'promo-code-table-list',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        memberList: [],
        fields: [
          {key: 'Id', label: 'PromoCodeId'},
          {key: 'PromoCode', label: 'Promo Code'},
          {key: 'Quantity', label: 'Quantity'},
          {key: 'ExpireOn', label: 'Expiry Date'},
          {key: 'Description', label: 'Description'},
          {key: 'Status', label: 'Status'},
          {key: 'AddTime', label: 'Added On'},
          {key: 'CreateOperator', label: 'Created By'},
          {key: 'UpdateTime', label: 'Modified On'},
          {key: 'ModifyOperator', label: 'Modified By'},
          {key: 'TotalMember', label: 'Total Registered'},
          {key: 'Action', label: 'Action'}
        ],
        statusOption: [
          {key: 1, label: 'Enable'},
          {key: 0, label: 'Disable'}
        ],
        searchDateByOption: [
          {key: 'addTime', label: 'Add Time'},
          {key: 'updateTime', label: 'Update Time'}
        ],
        currentPage: 1,
        rowCount: 0,
        perPage: 50,
        operator: '',
        sPromoCode: '',
        sExpireOn: '',
        sFrom: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        sTo: moment().format('YYYY-MM-DD'),
        sSearchDateBy: 'addTime',
        sCreateOperator: '',
        sModifyOperator: '',
        sStatus: null,
        addModal: false,
        updateModal: false,
        updateData: {},
        memberListModal: false,
        promoCode: '',
        verifyModal: false
      }
    },
    watch: {
      currentPage: function () {
        this.search()
      }
    },
    components: {
      AddModal,
      UpdateModal,
      MemberListModal,
      VerifyModal
    },
    methods: {
      getRowCount () {
        return this.rowCount
      },
      search () {
        Events.$emit('loader')
        let queryStr = `?promoCode=${this.sPromoCode}&expireOn=${this.sExpireOn}&from=${this.sFrom}&to=${this.sTo}&searchDateBy=${this.sSearchDateBy || ''}&createOperator=${this.sCreateOperator}&modifyOperator=${this.sModifyOperator}&size=${this.perPage}&page=${this.currentPage}&status=${this.sStatus || ''}`
        this.$http.get(this.API_ENDPOINT + '/promotion/promoCode/search' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.records
          this.rowCount = response.data.rowCount
          Events.$emit('loader')
        }).catch(err => {
          Events.$emit('loader')
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      async showMemberListModal (item) {
        try {
          Events.$emit('loader')
          let data = await this.$http.get(this.API_ENDPOINT + '/promotion/promoCode/member?promoCodeId=' + item.Id, {headers: { 'Content-Type': 'application/json' }})
          this.memberList = data.data.records
          this.promoCode = item.PromoCode
          this.memberListModal = true
          Events.$emit('loader')
        } catch (err) {
          Events.$emit('loader')
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async exportCSV () {
        try {
          Events.$emit('loader')
          let queryStr = `?promoCode=${this.sPromoCode}&expireOn=${this.sExpireOn}&from=${this.sFrom}&to=${this.sTo}&searchDateBy=${this.sSearchDateBy || ''}&createOperator=${this.sCreateOperator}&modifyOperator=${this.sModifyOperator}&status=${this.sStatus || ''}`
          let response = await this.$http.get(this.API_ENDPOINT + '/promotion/promoCode/search/export' + queryStr, {headers: { 'Content-Type': 'application/json' }})
          const url = window.URL.createObjectURL(new Blob([ response.data ]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `promo_code_report_${moment(this.sFrom).format('YYYYMMDD')}_${moment(this.sTo).format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          Events.$emit('loader')
        }
      },
      updateModalData (item) {
        this.updateModal = true
        this.updateData = item
      },
      closeUpdateModal () {
        this.updateModal = false
        this.updateData = {}
        this.search()
      },
      cancelAddModal () {
        this.addModal = false
        this.search()
      },
      closeMemberListModal () {
        this.memberList = []
        this.memberListModal = false
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      this.search()
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/promoCode/PromoCodeTable.vue